import React from "react";

import { Title } from "./styles";

const NotFound: React.FC = () => {
  return <Title>Página não encontrada</Title>;
};

export default NotFound;
